import { useState } from "react";
import "../assets/styles/form.scss";
import { SaveLeadDetails } from "../services/Api.service";

const LeadForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNo: "",
    companyName: "",
    designation: "",
    email: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "MobileNo") {
      newValue = value.replace(/\D/g, "");
      newValue = newValue.slice(0, 10);
    }

    if (name !== "MobileNo") {
      newValue = value.trimStart();
    }
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    try {
      const result = await SaveLeadDetails(formData);
      if (!result.hasError) {
        onSuccess();
      }
    } catch (error) {
        onSuccess();

    }
  };

  const isFormValid = () => {
    const { fullName, mobileNo, email, companyName, designation } = formData;
    const mobileRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const alphanumeric = /^[A-Za-z0-9 ]+$/;


    return (
      fullName.trim() !== "" && alphanumeric.test(fullName.trim()) &&
      companyName.trim() !== "" && alphanumeric.test(companyName.trim()) &&
      designation.trim() !== "" && alphanumeric.test(designation.trim()) &&
      mobileRegex.test(mobileNo.trim()) &&
      emailRegex.test(email.trim())
    );
  };

  return (
    <form onSubmit={handleSubmit} className="lead-form">
      <h2 className="form-title">Get Your Cyber Protection Today!</h2>
      <i className="note">No spam. Just what you need, when you need it.</i>

      <label>
        Full Name<sup className="text-danger">*</sup>
        <input
          type="text"
          name="fullName"
          placeholder="Enter your complete name"
          value={formData.fullName}
          onChange={handleChange}
          required
        />
      </label>

      <label>
        Email<sup className="text-danger">*</sup>
        <input
          type="text"
          name="email"
          placeholder="Your email address"
          value={formData.email}
          onChange={handleChange}
        />
      </label>

      <label>
        Mobile Number<sup className="text-danger">*</sup>
        <input
          type="tel"
          name="mobileNo"
          placeholder="10-digit active mobile number"
          value={formData.mobileNo}
          onChange={handleChange}
          pattern="\d{10}"
          maxLength={10}
          required
        />
      </label>

      <label>
        Company Name<sup className="text-danger">*</sup>
        <input
          type="text"
          name="companyName"
          placeholder="Name of your organization"
          value={formData.companyName}
          onChange={handleChange}
          required
        />
      </label>

      <label>
        Designation<sup className="text-danger">*</sup>
        <input
          type="text"
          name="designation"
          placeholder="Your job title/role"
          value={formData.designation}
          onChange={handleChange}
          required
        />
      </label>

      <button type="submit" className="btn" disabled={!isFormValid()}>
        Submit
      </button>
    </form>
  );
};

export default LeadForm;
